module.exports = __webpack_public_path__ + "img/docker.2eee24e8.png";